import React from 'react';

import { FundamentalInfoDataCell, FundamentalInfoContainer, FundamentalsContainer } from '../FundamentalInfo';
import { CoinData } from '@benzinga/crypto-manager';
import { formatLarge, formatPercentage } from '@benzinga/utils/numberUtils';

export interface CryptoFundamentalsProps {
  coin: CoinData;
}

const nullCheck = (value: number | string, callback: () => string) => {
  return value ? callback() : '–';
};

export const CryptoFundamentals: React.FC<CryptoFundamentalsProps> = ({ coin }) => (
  <FundamentalsContainer className="crypto-fundamentals">
    <tbody className="fundamentals-tbody">
      <FundamentalInfoContainer>
        <FundamentalInfoDataCell
          name="Market Cap"
          value={nullCheck(Number(coin.market_cap), () => `$${formatLarge(Number(coin.market_cap))}`)}
        />
        <FundamentalInfoDataCell
          name="Fully Diluted Valuation"
          value={nullCheck(coin.fully_diluted_valuation, () => `$${formatLarge(coin.fully_diluted_valuation)}`)}
        />
        <FundamentalInfoDataCell
          name="Total Volume"
          value={nullCheck(coin.total_volume, () => formatLarge(coin.total_volume))}
        />
      </FundamentalInfoContainer>
      <FundamentalInfoContainer>
        <FundamentalInfoDataCell name="All Time High (ATH)" value={nullCheck(coin.ath, () => `$${coin.ath}`)} />
        <FundamentalInfoDataCell
          name="ATH Change %"
          value={nullCheck(coin.ath_change_percentage, () => `${formatPercentage(coin.ath_change_percentage)}%`)}
        />
        <FundamentalInfoDataCell
          name="24hr High/Low"
          value={nullCheck(coin.low_24h || coin.high_24h, () => `$${coin.high_24h} / $${coin.low_24h}`)}
        />
      </FundamentalInfoContainer>
      <FundamentalInfoContainer>
        <FundamentalInfoDataCell
          name="Circulating Supply"
          value={nullCheck(coin.circulating_supply, () => formatLarge(coin.circulating_supply))}
        />
        <FundamentalInfoDataCell
          name="Total Supply"
          value={nullCheck(coin.total_supply, () => formatLarge(coin.total_supply))}
        />
        <FundamentalInfoDataCell
          name="Max Supply"
          value={nullCheck(coin.max_supply, () => formatLarge(coin.max_supply))}
        />
      </FundamentalInfoContainer>
    </tbody>
  </FundamentalsContainer>
);
